<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {}
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue